import $ from 'jquery'

export const init = () => {
  const galleryEl = $('.b-product__gallery')
  const galleryImagesEl = $('.b-product__gallery > a')
  const variantCheckboxEls = $('.product-colors--select > input')
  const variantSelectEl = $('#product-variant')
  const variantSelectOptionEls = $('#product-variant > option')
  const variantCodeEls = $('*[data-product-codes]')

  if (!galleryEl.length || (!variantCheckboxEls.length && !variantSelectEl.length) || !galleryImagesEl.length) {
    console.log('Required elements are missing.')
    return
  }

  // Function to read URL params
  const readURLParams = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantParam = urlParams.get('varianta');

    // P�id�me decodeURIComponent pro dek�dov�n� znak�
    console.log('URL parameter "varianta":', decodeURIComponent(variantParam));

    return variantParam ? decodeURIComponent(variantParam) : null;
  }


  // Function to normalize the variant string
  const normalizeVariant = (variantName) => {
    return variantName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[\s+]/g, '-').toLowerCase()
  }

  const normalizeString = (str) => {
    return str
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // Odstran�n� diakritiky
      .replace(/-/g, " ") // P�evod poml�ek na mezery
      .toLowerCase();
  };



  // Function to update URL with selected variant
  const updateURL = (variantName) => {
    const normalizedVariant = normalizeVariant(variantName)
    const currentUrl = window.location.href.split('?')[0]
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.set('varianta', normalizedVariant)
    const newUrl = `${currentUrl}?${urlParams.toString()}`
    console.log('Updating URL to:', newUrl)
    window.history.replaceState({}, '', newUrl)
  }

  // Function to set default variant for checkboxes
  const setDefaultVariantCheckbox = (variantName) => {
    let found = false
    if (variantCheckboxEls.length && variantName) {
      variantCheckboxEls.each(function() {
        const element = $(this)
        const valueNoDiacritics = element.val().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        if (normalizeVariant(valueNoDiacritics) === normalizeVariant(variantName)) {
          element.prop('checked', true)
          found = true
          console.log('Checkbox set to:', element.val())
        } else {
          element.prop('checked', false) // Uncheck other checkboxes
        }
      })
    }
    return found
  }

  // Function to set default variant for select
  const setDefaultVariantSelect = (variantName) => {
    let found = false;

    if (variantSelectOptionEls.length && variantName) {
      variantSelectOptionEls.each(function() {
        const element = $(this);
        const value = element.val();

        // Normalizace obou hodnot (z URL i selectu)
        const normalizedURLVariant = normalizeString(variantName);
        const normalizedSelectVariant = normalizeString(value);

        console.log('Porovn�v�m variantu z URL:', normalizedURLVariant, 's hodnotou selectu:', normalizedSelectVariant);

        if (normalizedURLVariant === normalizedSelectVariant) {
          variantSelectEl.val(value); // Zm�n�no z element.val() na value
          found = true;
          console.log('Select set to:', value);
          return false; // Zastav� cyklus, jakmile se najde spr�vn� hodnota
        }
      });
    }

    return found;
  };




  const updateGalleryImages = (checkboxValue) => {
    galleryImagesEl.each(function() {
      const $imageEl = $(this)
      const variantString = $imageEl.data('variant')
      if (!variantString || !checkboxValue) {
        $imageEl.show()
        return
      }
      if (variantString.toLowerCase().includes(checkboxValue.toLowerCase())) {
        $imageEl.show()
      } else {
        $imageEl.hide()
      }
    })
  }

  const updateVariantCodes = (checkboxValue) => {
    if (!variantCodeEls.length) {
      return
    }
    if (variantCodeEls.length === 1 || !checkboxValue) {
      variantCodeEls.first().show()
      return
    }
    variantCodeEls.each(function() {
      const $element = $(this)
      if ($element.data('product-codes') === checkboxValue) {
        $element.show()
      } else {
        $element.hide()
      }
    })
  }

  const updatePrice = (variantCode) => {

  };

  const updateUI = (initial = false) => {
    let variantCode = null

    if (variantCheckboxEls.length) {
      variantCheckboxEls.each(function() {
        const element = $(this)
        if (element.is(':checked')) {
          variantCode = element.val()
        }
      })
    } else if (variantSelectEl.length) {
      variantCode = variantSelectEl.val()
    }

    // If this is the initial call and no variantCode is set, use the first available variant
    if (initial && !variantCode) {
      if (variantCheckboxEls.length) {
        variantCheckboxEls.first().prop('checked', true)
        variantCode = variantCheckboxEls.first().val()
      } else if (variantSelectOptionEls.length) {
        variantSelectEl.val(variantSelectOptionEls.first().val())
        variantCode = variantSelectOptionEls.first().val()
      }
    }

    if (variantCode) {
      updateURL(variantCode);
      updatePrice(variantCode);
    }

    console.log('Updating UI for variant:', variantCode)
    updateGalleryImages(variantCode)
    updateVariantCodes(variantCode)
  }

  // Read URL parameter for variant
  const variantName = readURLParams()

  // Set default variant based on URL parameter
  console.log(variantName);
  const checkboxSet = setDefaultVariantCheckbox(variantName)
  const selectSet = setDefaultVariantSelect(variantName)

  // Initial UI update
  updateUI(true) // Pass true to indicate this is the initial call
  updatePrice(readURLParams());


  if (variantCheckboxEls.length) {
    variantCheckboxEls.on('change', updateUI)
  }
  if (variantSelectEl.length) {
    variantSelectEl.on('change', updateUI)
  }
}


// Call the init function on DOMContentLoaded
$(document).ready(() => {
  init()
})

